import type { Types } from 'mongoose'
import { defineStore } from 'pinia'

export const useUserStore = defineStore('user', () => {
  const tagStore = useTagStore()

  const token = useCookie('token')

  const user = ref<Ccd.AdminDoc & {
    role: Ccd.RoleDoc
    agent?: Ccd.AgentDoc
    site?: Ccd.SiteDoc
    _id: Types.ObjectId
  }>()

  const userRole = computed(() => user.value?.role || { level: 100 })
  const site = computed(() => user.value?.site || {})

  const menus = ref<string[]>([])

  const roles = ref<Ccd.RoleDoc[]>([])

  const homeStat = ref<Ccd.HomeStat>({ todayNewTrainee: 0, yesterdayNewTrainee: 0, monthNewTrainee: 0, onlineTrainee: 0 })

  const login = async (username: string, password: string) => {
    await $fetch('/api/auth/session', { method: 'post', body: { username, password } })
    navigateTo({ path: '/home', replace: true })
  }

  const logout = async () => {
    await $fetch('/api/auth/session', { method: 'delete' })
    navigateTo({ path: '/login', replace: true })
  }

  const boost = async () => {
    const res = await $fetch('/api/boost', {
      headers: {
        authorization: token.value || '',
      },
    })
    menus.value = res.menus
    roles.value = res.roles
    user.value = res.admin as any
    homeStat.value = res.homeStat
    tagStore.tags = res.tags
  }

  const safeFetch = () => {
    return $fetch.create({
      method: 'post',
      headers: {
        authorization: token.value || '',
      },
    })
  }

  return { token, user, site, userRole, menus, roles, homeStat, safeFetch, login, logout, boost }
})
